import { UserContext } from "@/context/UserContext";
import { isAgentsDemoMode } from "@/libs/agentsMode";

/**
 * The Investment Banking preview content is demo content: the onboarding flag
 * in agent demo mode (`isAgentsMock`) enables all of it, and a live tenant
 * never sees it.
 */
export const isInvestmentBankingDemo = (): boolean =>
  UserContext.hasConfigParameter("isNewAgentOnboarding") && isAgentsDemoMode();
